import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { Capacitor } from "@capacitor/core";
import { SafeArea } from "capacitor-plugin-safe-area";
import { StatusBar, Style } from "@capacitor/status-bar";

interface SafeAreaInset {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

const isDebug = false;

function setCSSVariablesFromInsets(insets: SafeAreaInset) {
  Object.entries(insets).forEach(([key, value]) => {
    document.body.style.setProperty(`--safe-area-inset-${key}`, `${value}px`);
  });
}

async function applySafeAreaInsets(): Promise<void> {
  try {
    const { insets } = await SafeArea.getSafeAreaInsets();
    setCSSVariablesFromInsets(insets);
  } catch (error) {
    console.warn("[SafeArea] Failed to apply insets:", error);
  }
}

async function setStatusBarStyle(): Promise<void> {
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });

    const { statusBarHeight } = await SafeArea.getStatusBarHeight();
    if (isDebug) console.log("[StatusBar] Height:", statusBarHeight);
    const { style } = await StatusBar.getInfo();
    const backgroundMap: Record<Style, string> = {
      [Style.Dark]: "#121212",
      [Style.Light]: "#ffffff",
      [Style.Default]: "transparent"
    };

    const backgroundColor = backgroundMap[style] ?? "transparent";
    document.body.style.setProperty("--body-background-color", backgroundColor);
  } catch (error) {
    console.warn("[StatusBar] Failed to apply style:", error);
  }
}

async function initializeNativeUI(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  await Promise.all([setStatusBarStyle()]);
}

bootstrapApplication(AppComponent, appConfig)
  .then(initializeNativeUI)
  .catch((err) => console.error("[Bootstrap] Failed:", err));
